import React, { useState, useEffect } from "react";
import Header from "../../components/header1/Header1";
import Footer from "../../components/footer/Footer";
import landing2 from "../../elements/Group 171.png";
import anushreePhoto from "../../elements/anushree's profile photo.jpg";
import mayurPhoto from "../../elements/Mayur's profile photo.png";
import { FaEnvelope, FaPhone, FaLinkedin } from 'react-icons/fa';
import bannerImage from "../../elements/Group 130.png";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import ReactPlayer from "react-player"
import PartnerInstitutions from "../../components/partner/Partner";

// import mitlogo from "../../elements/mitaurangabadlogo.png";

const KnowYourProgramCoordinators = () => {

    const [instituteCoordinators, setInstituteCoordinators] = useState([]);
    const [collegeProfilePhoto, setcollegeProfilePhoto] = useState([]);
    const [loading, setLoading] = useState(true);
    const [coordinatorList, setCoordinatorList] = useState([]);

    const [hasCoordinators, setHasCoordinators] = useState(false);

    const AgivantCoordinators = [
        {
            coordinatorId: 1,
            coordinatorName: "Anushree Rai",
            coordinatorBio:
                "HR Head at Agivant, Anushree Rai is your point of contact for mentorship and guidance related to the AI Amplified Software Engineering Program.",
            coordinatorEmail: "aiampdse@agivant.com",
            coordinatorPhoneNo: "+91 7503997792",
            coordinatorLinkedIn: "https://www.linkedin.com/in/anushree-rai-95722076/",
            profilePhoto: anushreePhoto,
        },
        {
            coordinatorId: 2,
            coordinatorName: "Mayur Mulik",
            coordinatorBio:
                "Managing HR Ops and Admin at Agivant, please connect with Mayur for assistance with enrolments, timelines, or system-related queries.",
            // coordinatorEmail: "mayur.mulik@agivant.com",
            coordinatorEmail: "aiampdse@agivant.com",
            coordinatorPhoneNo: "+91 7507903474",
            coordinatorLinkedIn: "https://www.linkedin.com/in/mayur-mulik-384276203/",
            profilePhoto: mayurPhoto,
        },
    ];

    useEffect(() => {
        const fetchInstituteCoordinators = async () => {
            try {
                const savedStudentDetails = localStorage.getItem("student-details"); // Fetch data from local storage
                if (!savedStudentDetails) {
                    throw new Error("No data found in local storage");
                }

                const parsedStudentData = JSON.parse(savedStudentDetails); // Parse JSON string
                setInstituteCoordinators(parsedStudentData.coordinators); // Set the coordinators
                setcollegeProfilePhoto(parsedStudentData.collegeProfilePhoto); // Set the college photo
            } catch (error) {
                console.error("Error fetching institute coordinators:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchInstituteCoordinators();
    }, []);


    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="md:mx-20 ">
            <Header />
            <div className="relative w-full">
                <img
                    src={bannerImage}
                    alt="Banner"
                    className="w-full sm:h-[300px] h-auto object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-medium p-4 sm:p-6">
                    <div className="flex flex-col w-full sm:w-2/5 p-3">
                        {/* <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Introducing Your</p>
                        <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Program Coordinators</p>
                        <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">for this Journey.</p> */}
                        <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
                        Introducing Your Program Coordinators for this Journey.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mainPage text-base xl:text-4xl">
                <div className="flex flex-col md:flex-row items-center py-10 gap-6">
                    <div className="w-full md:w-1/2 h-full">
                        <img src={landing2} alt="Learning Program" className="w-full h-auto" />
                    </div>
                    <div className="w-full md:w-1/2 leading-relaxed space-y-2 px-2 md:px-0">
                        <p className="font-bold text-3xl text-left">Seeking Guidance for Your Program?</p>
                        <p className="text-left font-medium md:text-2xl sm:text-lg text-gray-700 pt-2">
                            Your program coordinators are here to assist you with any questions, concerns, or academic guidance you may need. On this page, you will find the contact information for your program coordinators. Feel free to reach out to them via email or phone to schedule appointments or discuss any issues related to your coursework, academic progress, or future plans.
                        </p>
                    </div>
                </div>



                {instituteCoordinators && (


                    <div className="py-2 my-2">
                        <section className="bg-purple-100 py-8  px-8 md:px-12 md:py-14">
                            <div className="flex items-center justify-between w-full">
                                
                                <div className="flex items-left" >
                                    <p className="text-4xl md:text-4xl font-bold text-gray-800 text-left leading-tight">
                                        Institute Program Coordinators
                                    </p>
                                </div>

                               
                                <div
                                    className="flex items-left justify-center"
                                    style={{ width: "40%", height: "100px" }}
                                >
                                    {collegeProfilePhoto ? (
                                        <img
                                            src={collegeProfilePhoto}
                                            alt="College Logo"
                                            className="object-contain"
                                            style={{ height: "100%", width: "auto" }}
                                        />
                                    ) : null}
                                </div>
                            </div>

                            <div className="max-w-4xl  flex flex-col justify-center">
                                {instituteCoordinators.map((coordinator) => (
                                    <div key={coordinator.coordinatorId} className="py-4  flex flex-col md:flex-row items-start ">
                                        <div className="w-full md:w-1/4 ">
                                            <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-28 md:h-28 lg:w-36 lg:h-36 rounded-full border-gray-200 border-1 overflow-hidden bg-gray-200 flex justify-start items-left mb-4 sm:mb-0 mx-2">
                                                <img src={coordinator.profilePhoto} alt={`${coordinator.coordinatorName}`} className="object-cover w-full h-full" />
                                            </div>
                                        </div>
                                        <div className="flex flex-col md:ml-6 lg:ml-8 w-full">
                                            <p className="text-3xl md:text-3xl sm:text-xl font-semibold text-blue-800 text-left">{coordinator.coordinatorName}</p>
                                            {/* <p className="text-black-600 font-semibold text-left text-wrap leading-5 text-normal md:text-normal xs:text-base sm:leading-5 break-words">
                                                {coordinator.coordinatorBio}
                                            </p> */}
                                            <hr className="border-t-2" />
                                            <div className="flex flex-col mt-2 pl-2 justify-between md:flex-row md:items-center text-gray-600 space-y-1 md:space-x-1 md:space-y-0">
                                                <a href={`mailto:${coordinator.coordinatorEmail}`} className="flex items-center hover:text-gray-800 text-left">
                                                    <CiMail className="w-5 h-5 mr-2 top-1/2 transform -translate-y-1/2" />
                                                    <p className="font-normal text-sm">{coordinator.coordinatorEmail}</p>
                                                </a>
                                                {/* <a href={`tel:${coordinator.coordinatorPhoneNo}`} className="flex items-center hover:text-gray-800 text-left">
                                                    <IoCallOutline className="w-5 h-5 mr-2 top-1/2 transform -translate-y-1/2" />
                                                    <p className="font-normal text-sm">{coordinator.coordinatorPhoneNo}</p>
                                                </a> */}
                                                {/* <a href={coordinator.coordinatorLinkedIn} className="flex items-center hover:text-gray-800 text-left">
                                                    <FaLinkedin className="w-5 h-5 mr-2 top-1/2 transform -translate-y-1/2 text-[#0A66C2]" />
                                                    <p className="font-normal text-sm">Connect via LinkedIn</p>
                                                </a> */}
                                                </div>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                )}


                <div className="py-2 my-2">
                    <section className=" py-8 px-8 md:px-12">
                        <p className="text-4xl  md:text-4xl font-bold text-gray-800 text-left mb-6">
                            Agivant Team Coordinators
                        </p>
                        <div className="max-w-4xl flex flex-col justify-center">
                            {AgivantCoordinators.map((AgivantCoordinator) => (
                                <div key={AgivantCoordinators.coordinatorId} className="py-4  flex flex-col md:flex-row items-start">
                                    <div className="w-full md:w-1/4">
                                        <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-28 md:h-28 lg:w-36 lg:h-36 rounded-full border-gray-200 border-1 overflow-hidden bg-gray-200 flex justify-start items-left mb-4 sm:mb-0 mx-2">
                                            <img src={AgivantCoordinator.profilePhoto} alt={`${AgivantCoordinator.coordinatorName}`} className="object-cover  w-full h-full" />
                                        </div>
                                    </div>
                                    <div className="flex flex-col md:ml-6 lg:ml-8 w-full">
                                        <p className="text-3xl md:text-3xl sm:text-xl font-semibold text-blue-800 text-left">{AgivantCoordinator.coordinatorName}</p>
                                        <p className="text-black-600 font-semibold text-left leading-5 text-normal md:text-normal xs:text-base sm:leading-5 break-words">
                                            {AgivantCoordinator.coordinatorBio}
                                        </p>
                                        <hr className="border-t-2" />
                                        <div className="flex flex-col mt-2 pl-2 justify-between md:flex-row md:items-center text-gray-600 space-y-1 md:space-x-2 md:space-y-0">
                                            <a href={`mailto:${AgivantCoordinator.coordinatorEmail}`} className="flex items-center hover:text-gray-800">
                                                <CiMail className="relative w-5 h-5 top-1/2 transform -translate-y-1/2 text-left" />
                                                <p className="font-normal text-sm">{AgivantCoordinator.coordinatorEmail}</p>
                                            </a>
                                            {/* <a href={`tel:${AgivantCoordinator.coordinatorPhoneNo}`} className="flex items-center hover:text-gray-800">
                                                <IoCallOutline className="relative w-5 h-5 top-1/2 transform -translate-y-1/2 text-left" />
                                                <p className="font-normal text-sm">{AgivantCoordinator.coordinatorPhoneNo}</p>
                                            </a> */}
                                            <a href={AgivantCoordinator.coordinatorLinkedIn} className="flex items-center hover:text-gray-800">
                                                <FaLinkedin className="relative w-5 h-5 top-1/2 transform -translate-y-1/2 text-left text-[#0A66C2]" />
                                                <p className="font-normal text-sm">Connect via LinkedIn</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>



<div className="text-center py-8">
          <h2 className="text-3xl font-bold mb-6">
            Our Campus Tour
          </h2>
          <div className="flex relative w-full sm:w-11/12 lg:w-3/4 xl:w-4/5 max-w-6xl mx-auto px-4 items-center justify-center">
            
            <ReactPlayer
              controls={true}
              url="https://www.youtube.com/watch?v=mF3yJoC62TU"
              // url="https://youtu.be/sB9yId9cfdY?si=65zNH4OIcDQVUjfq"
            />
          </div>
        </div> 



            </div>

            {/* <PartnerInstitutions /> */}
            <Footer />
        </div>
    );
};

export default KnowYourProgramCoordinators;
